(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals(root) {
    const nodes = root.querySelectorAll('[data-cs-reveal]');
    if (!nodes.length) return;
    if (reduce) {
      nodes.forEach((el) => el.classList.add('is-in'));
      return;
    }
    requestAnimationFrame(() => {
      nodes.forEach((el) => el.classList.add('is-in'));
    });
  }

  function initStars(root) {
    const canvas = root.querySelector('[data-cs-stars]');
    if (!canvas || reduce) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    let w = 0;
    let h = 0;
    let stars = [];
    let raf = 0;

    function resize() {
      const rect = root.getBoundingClientRect();
      w = Math.max(1, Math.floor(rect.width));
      h = Math.max(1, Math.floor(rect.height));
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = w * dpr;
      canvas.height = h * dpr;
      canvas.style.width = `${w}px`;
      canvas.style.height = `${h}px`;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      stars = Array.from({ length: Math.floor((w * h) / 14000) + 28 }, () => ({
        x: Math.random() * w,
        y: Math.random() * h,
        r: Math.random() * 1.4 + 0.3,
        a: Math.random() * 0.6 + 0.15,
        s: Math.random() * 0.25 + 0.05,
        p: Math.random() * Math.PI * 2,
      }));
    }

    function tick(t) {
      ctx.clearRect(0, 0, w, h);
      stars.forEach((star) => {
        star.y -= star.s;
        if (star.y < -4) star.y = h + 4;
        const twinkle = 0.55 + Math.sin(t * 0.002 + star.p) * 0.45;
        ctx.beginPath();
        ctx.fillStyle = `rgba(247, 243, 234, ${star.a * twinkle})`;
        ctx.arc(star.x, star.y, star.r, 0, Math.PI * 2);
        ctx.fill();
      });
      raf = requestAnimationFrame(tick);
    }

    resize();
    window.addEventListener('resize', resize, { passive: true });
    raf = requestAnimationFrame(tick);

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener('resize', resize);
    };
  }

  function initCountdown(root) {
    const box = root.querySelector('[data-cs-countdown]');
    if (!box) return;

    const section = document.querySelector('[data-cs-launch]');
    const iso =
      (section && section.getAttribute('data-cs-launch')) ||
      box.getAttribute('data-launch') ||
      '';

    // Optional: read from nearby script tag / schema via data attribute on page
    const launchAttr = root.getAttribute('data-launch-iso') || iso;
    if (!launchAttr) return;

    const target = new Date(launchAttr).getTime();
    if (!Number.isFinite(target)) return;

    box.hidden = false;
    const daysEl = box.querySelector('[data-cs-days]');
    const hoursEl = box.querySelector('[data-cs-hours]');
    const minsEl = box.querySelector('[data-cs-mins]');
    const secsEl = box.querySelector('[data-cs-secs]');

    function pad(n) {
      return String(Math.max(0, n)).padStart(2, '0');
    }

    function update() {
      const diff = target - Date.now();
      if (diff <= 0) {
        daysEl.textContent = '00';
        hoursEl.textContent = '00';
        minsEl.textContent = '00';
        secsEl.textContent = '00';
        return;
      }
      const days = Math.floor(diff / 86400000);
      const hours = Math.floor((diff % 86400000) / 3600000);
      const mins = Math.floor((diff % 3600000) / 60000);
      const secs = Math.floor((diff % 60000) / 1000);
      daysEl.textContent = pad(days);
      hoursEl.textContent = pad(hours);
      minsEl.textContent = pad(mins);
      secsEl.textContent = pad(secs);
    }

    update();
    setInterval(update, 1000);
  }

  document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector('[data-coming-soon]');
    if (!root) return;
    initReveals(root);
    initStars(root);
    initCountdown(root);
  });
})();
